import {Component} from "../interface/component";

export class SocialComponent implements Component {

    private $root:JQuery;

    constructor(elem:HTMLElement) {
        this.$root = $(elem);
    }

    init() {
        this.bindUI();
    }

    /**
     * Sets up fancy box for this gallery. Sets up filter functionality.
     */
    private bindUI() {
        $('.js-share__facebook', this.$root).on('click', this.shareToFacebook);
        $('.js-share__linkedin', this.$root).on('click', this.shareToLinkedin);
        $('.js-share__twitter', this.$root).on('click', this.shareToTwitter);
    }

    private shareToFacebook = (event:any) => {
        event.preventDefault();
        let link = (<any>window).page_data.page_link;
        window.open("https://www.facebook.com/sharer/sharer.php?u=" + encodeURI(link), "pop", "width=600, height=400, scrollbars=no");
    };

    private shareToLinkedin = (event:any) => {
        event.preventDefault();
        let title = (<any>window).page_data.page_title;
        let link = (<any>window).page_data.page_link;
        let summary = (<any>window).page_data.page_summary;
        var url = "https://www.linkedin.com/sharing/share-offsite?title=" + encodeURI(JSON.parse(title)) + "&summary=" + encodeURI(JSON.parse(summary)) + "&url=" + encodeURI(link);
        window.open(url, "pop", "width=600, height=400, scrollbars=no");
    };

    private shareToTwitter = (event:any) => {
        event.preventDefault();
        let title = (<any>window).page_data.page_title;
        let link = (<any>window).page_data.page_link;
        var url = "https://twitter.com/intent/tweet?text=" + encodeURIComponent(JSON.parse(title)) + " - " + encodeURI(link);
        window.open(url, "pop", "width=600, height=400, scrollbars=no");
    };
}